import axios from 'axios';
import { getAuthToken } from './AuthService';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/api',
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// On 401, the stored token is invalid or expired — clear it and redirect to login.
// Skip the login endpoint itself: a 401 there means wrong credentials, not an expired session.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url = error.config?.url || '';
            if (!url.includes('/auth/login')) {
                localStorage.removeItem('userDetails');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
